<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M6.38625 15.5437C6.00784 14.6931 5.79688 13.7468 5.79688 12.7496C5.79688 9.04603 8.70703 6.0437 12.2969 6.0437C15.8868 6.0437 18.7969 9.04603 18.7969 12.7496C18.7969 13.7468 18.5859 14.6931 18.2075 15.5437"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M12.2969 2.5437V3.5437"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M22.2969 12.5437H21.2969"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.29688 12.5437H2.29688"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.3673 5.47241L18.6602 6.17952"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.93367 6.1805L5.22656 5.47339"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.8139 19.8501C15.8243 19.5233 16.2295 18.5985 16.3435 17.6683C16.3775 17.3904 16.1489 17.1599 15.8689 17.1599L8.77373 17.1601C8.48413 17.1601 8.25155 17.4059 8.28613 17.6934C8.39778 18.6218 8.67958 19.3 9.75033 19.8501M14.8139 19.8501C14.8139 19.8501 9.92659 19.8501 9.75033 19.8501M14.8139 19.8501C14.6924 21.7951 14.1307 22.5654 12.3037 22.5438C10.3495 22.5799 9.89991 21.6278 9.75033 19.8501"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>